import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import { getAllColumns } from "./AllColumnsData";
import { Table } from "antd";
import useFetchContacts from "../../../disaster/hooks/useFetchContacts";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import FETCH from "../../../../../utils/fetch";

const moduleNames = [
  "Joint Obligations",
  "Individual Obligations",
  "Pre Marriage Debt",
];

export default function DebtAndLiabilities() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Debt And Liabilities");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const tableDataObj = {
    "Joint Obligations": tableData.jointObligationsData,
    "Individual Obligations": tableData.individualObligationsData,
    "Pre Marriage Debt": tableData.preMarriageDebtData,
  };

  console.log("Table Data Devt", tableData);
  const { contactList } = useFetchContacts(setLoading);
  const getLiabilitesList = async () => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liabilities and Credit&page=1&limit=50&clientId=${ID}`
            : `?module=Liabilities and Credit&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        datares.records.map((item) => {
          if (item.subType == "Credit") {
            item["Nickname of Liabilities"] = item["Nickname of Credit"];
            item["Initial Loan Amount"] = item["Credit Balance"];
            item["Interest Rate"] = item["Interest Rate (or APR%)"];
            item["Maturity Date"] = item["Point Expiration"];
            item["Name of Financial Institution"] = item["Name of Issuer"];
            item["Monthly Payment"] =
              item["Monthly Payment"] && item["Monthly Payment"].toString();
            item["Start Date"] = new Date();
            item["subType"] = item.subType;
          }
        });
        setLiabilitesCredit(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const jointObligationsTable = [{ title: "Joint Obligations", key: 1 }];

  const individualObligationsTable = [
    { title: "Individual Obligations", key: 2 },
  ];

  const preMarriageTable = [{ title: "Pre Marriage Debt", key: 3 }];

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };

  useEffect(() => {
    getLiabilitesList();
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div
          style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}
        >
          <h2 className="parent-title">Debt And Liabilities</h2>
          <ToolTipCreator name={"Divorce_Debt_Liabilities"} />
        </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon || "/placeholder.svg"} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      <div className="child-title-container">
        <h2 className="child-title">Joint Obligations</h2>
      </div>
      {jointObligationsTable.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          //   handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={() => showModal(table.title)}
          options={liabilitiesCredit && liabilitiesCredit}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <div className="child-title-container">
        <h2 className="child-title">Individual Obligations</h2>
      </div>
      {individualObligationsTable.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          //   handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={() => showModal(table.title)}
          options={liabilitiesCredit && liabilitiesCredit}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <div className="child-title-container">
        <h2 className="child-title">Pre-Marriage Debt</h2>
      </div>
      {preMarriageTable.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          //   handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={() => showModal(table.title)}
          options={liabilitiesCredit && liabilitiesCredit}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      <CustomModal
        show={isModalVisible}
        fields={attributesData}
        modalTitle={modalTitle}
        close={handelCloseModal}
        onChange={handleChange}
        onSelectChange={handleItemsInfoSelect}
        submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
        selectedRowData={formData}
        handleItemsInfoImageChange={formData}
        loading={loading}
      />
      <NewLoader isLoading={loading} />
    </div>
  );
}
